import { tw } from '@/utils/tw';
import ArticlePaywallFormThemeBase from 'base/components/standalone/ArticlePaywall/Form/theme';

const ArticlePaywallFormTheme = tw.theme({
  extend: ArticlePaywallFormThemeBase,
  slots: {
    policy: ['text-body-sm', '[&>a]:text-red-950', '[&>a]:underline'],
    caption: ['text-body-sm', '[&>a]:text-black', '[&>a]:underline'],
  },
});

export default Object.assign(ArticlePaywallFormTheme, {
  Button: ArticlePaywallFormThemeBase.Button,
  TextField: ArticlePaywallFormThemeBase.TextField,
  CheckboxField: ArticlePaywallFormThemeBase.CheckboxField,
});
